import {getScrollWidth} from "../utility/_get-scroll-width";

export function popupsInit() {
    $(document).on("click", '.popupOpen, .popup-open', function(e) {
        e.preventDefault();
        const href = $(this).attr('href');
        const $popup = $(href);

        showPopup($popup);
    })

    $(document).one('keydown', e => {
        if (e.key.toUpperCase() === "ESCAPE") {
            $('.popup:visible .popup-close').trigger("click");
        }
    });

    $(document).on("click", '.popup:visible .popup-close', function() {
        hidePopup($(this).parents('.popup'));
    });
}

export function showPopup($popup) {
    $(document.body).addClass('windowOpen');
    $(document.body).css('padding-right', getScrollWidth);
    $popup.fadeIn();
}

export function hidePopup($popup) {
    $popup.fadeOut(function() {
        if (!$('.popup:visible').length) {
            $(document.body).removeClass('windowOpen');
            $(document.body).css('padding-right', '');
        }
    });
}

export function removePopup($popup) {
    $popup.fadeOut(function() {
        $popup.remove();

        if (!$('.popup:visible').length) {
            $(document.body).removeClass('windowOpen');
            $(document.body).css('padding-right', '');
        }
    });
}

window.PTWP = window.PTWP || {};
window.PTWP.popups = {};
window.PTWP.popups.show = showPopup;
window.PTWP.popups.hide = hidePopup;
window.PTWP.popups.remove = removePopup;
